module.exports = function isDollarVariable(property) {
	return property[0] === '$';
};
